import { render, staticRenderFns } from "./gruposcliente-form.vue?vue&type=template&id=21a797eb&scoped=true"
import script from "./gruposcliente-form.vue?vue&type=script&lang=js"
export * from "./gruposcliente-form.vue?vue&type=script&lang=js"
import style0 from "./gruposcliente-form.vue?vue&type=style&index=0&id=21a797eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a797eb",
  null
  
)

export default component.exports